/**
 * Uniba Footer reducer
 * @module src/reducers/unibaFooterReducer
 */

import { GET_UNIBA_FOOTER } from 'design-comuni-plone-theme/actions';

const initialState = {
  error: null,
  hasError: false,
  result: {},
  loadingResults: false,
};

export const unibaFooterReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case `${GET_UNIBA_FOOTER}_PENDING`:
      return {
        ...state,
        loadingResults: true,
      };

    case `${GET_UNIBA_FOOTER}_SUCCESS`:
      return {
        ...state,
        result: action.result,
        loadingResults: false,
      };

    case `${GET_UNIBA_FOOTER}_FAIL`:
      return {
        ...state,
        error: action.error,
        hasError: true,
        loadingResults: false,
      };

    default:
      return state;
  }
};
